"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var uuid = _interopRequireWildcard(require("uuid"));

var _react = require("react");

var _jwtDecode = require("jwt-decode");

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }

function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }

var useClientSourceId = function useClientSourceId(_ref) {
  var clientKey = _ref.clientKey,
      userId = _ref.userId,
      authorization = _ref.authorization,
      id = _ref.id,
      localStorage = _ref.localStorage;
  var clientSourceKey = (0, _react.useMemo)(function () {
    var _decoded$scope, _decoded$scope$split, _decoded$scope$split$;

    if (!authorization) {
      return "".concat(clientKey, "/").concat(userId);
    }

    var decoded = (0, _jwtDecode.jwtDecode)(authorization);
    var scopeUserId = decoded === null || decoded === void 0 ? void 0 : (_decoded$scope = decoded.scope) === null || _decoded$scope === void 0 ? void 0 : (_decoded$scope$split = _decoded$scope.split(" ")) === null || _decoded$scope$split === void 0 ? void 0 : (_decoded$scope$split$ = _decoded$scope$split.find(function (s) {
      return s.includes("user_id");
    })) === null || _decoded$scope$split$ === void 0 ? void 0 : _decoded$scope$split$.replace("user_id:", "");
    return "".concat(decoded === null || decoded === void 0 ? void 0 : decoded.tenant_id, "/").concat(scopeUserId);
  }, [authorization, clientKey, userId]);
  return (0, _react.useMemo)(function () {
    if (!localStorage) {
      return;
    }

    var clientSourceIdLSKey = "clientSourceId/".concat(clientSourceKey);
    var localStorageClientSourceId = localStorage.getItem(clientSourceIdLSKey);

    if (localStorageClientSourceId) {
      return id ? "".concat(localStorageClientSourceId, "/").concat(id) : localStorageClientSourceId;
    }

    var newClientSourceId = uuid.v4();
    localStorage.setItem(clientSourceIdLSKey, newClientSourceId);
    return id ? "".concat(newClientSourceId, "/").concat(id) : newClientSourceId;
  }, [localStorage, clientSourceKey, id]);
};

var _default = useClientSourceId;
exports["default"] = _default;